module.exports = __webpack_public_path__ + "assets/img/image(5).847607e7.png";